import { Permission } from '@/types/common';
import {
  hasPermission as checkPermission,
  hasAnyPermission as checkAny,
  hasAllPermissions as checkAll,
} from '@/constants/permissions';
import { useAuth } from './useAuth';

export function useAuthorization() {
  const { profile, loading: authLoading, profileLoading } = useAuth();
  const role = profile?.role ?? '';
  const loading = authLoading || profileLoading;

  return {
    role,
    loading,
    hasPermission: (permission: Permission) => checkPermission(role, permission),
    hasAnyPermission: (permissions: Permission[]) => checkAny(role, permissions),
    hasAllPermissions: (permissions: Permission[]) => checkAll(role, permissions),
  };
}
